








import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { stProjectApi } from "@/services/st-api";
import { ProjectCheckFixedPriceChangeCommand } from "@/services/api/nswag/stapiclient_generated";
import { notifyError } from "@/utlitities/notifications";

@Component({
  components: {}
})
export default class ProjectChangeFixedPriceWarning extends Vue {
  @Prop() isFixedPrice!: boolean;
  @Prop() projectId!: number;

  watchFn: any;
  warningTextDisplay: string | null = null;

  async mounted(){
    if(this.isFixedPrice === false || this.isFixedPrice === true){
      await this.checkFixedPrice();
    }

    this.watchFn = this.$watch('isFixedPrice', async ()=>{
      await this.checkFixedPrice();
    })
  }

  beforeDestroy(){
    this.watchFn();
  }

  async checkFixedPrice() {
    this.warningTextDisplay = null;

    const checkResult = await stProjectApi.checkFixedPriceChange(ProjectCheckFixedPriceChangeCommand.fromJS({
      id: this.projectId,
      changeFixedPriceValueTo: this.isFixedPrice
    }));

    if(!checkResult.canBeChanged){
      notifyError(checkResult.warningText);
      return;
    }

    this.warningTextDisplay = checkResult.warningText;
  }
}
